export type UserEntity = {
  uuid: string
  lockVersion: number
  name: string
  code: string
  email: string
  iconUrl: string
}

// 各項目の最大文字数と許可文字。テナントごとに上書きできない値のため、
// バックエンドの機能プロパティ（function_properties）の定義値を定数として写している。
export const USER_NAME_MAX_LENGTH = 32
export const USER_NAME_KANA_MAX_LENGTH = 32
export const USER_NAME_ALPHABET_MAX_LENGTH = 256
export const USER_PHONE_NUMBER_MAX_LENGTH = 256
// 英字表記は半角英字と半角空白のみ（末尾の空白は許可文字の一部で、削らない）。
export const USER_NAME_ALPHABET_CHARACTERS_ALLOWED = 'a-zA-Z '
export const USER_PHONE_NUMBER_CHARACTERS_ALLOWED = '+0-9-'

// メールアドレスの変更は本登録が完了しているユーザーにのみ許可する。
const REGISTRATION_STATUS_FINAL = 'FINAL'
export const isEmailChangeable = (
  registrationStatus: string | undefined
): boolean => registrationStatus === REGISTRATION_STATUS_FINAL
